module.exports = __webpack_public_path__ + "img/VATTENFALL.f3aa52f7.png";